

const ConfirmModal = ({
  title = "Confirm Action",
  message = "Are you sure?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  loading = false,
  onConfirm,
  onClose,
}) => {

  return (

    <div
      className="modal-overlay"
      onClick={onClose}
    >

      <div
        className="modal-box modal-box--sm delete-modal-box"
        onClick={(e) =>
          e.stopPropagation()
        }
      >

        <center>

          <p className="delete-modal-text">

            <strong>{title}</strong>

            <br /><br />

            {message}

          </p>

        </center>

        <div className="delete-modal-actions">

          <button
            className="org-btn-cancel"
            onClick={onClose}
            disabled={loading}
          >
            {cancelText}
          </button>

          <button
            className="delete-btn"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading
              ? "Please wait..."
              : confirmText}
          </button>

        </div>

      </div>

    </div>

  );
};

export default ConfirmModal;